// How loud a stream is on each frame, from 0 to 1. Returns how to stop listening.
export function watchVoiceLevel(
  stream: MediaStream,
  onLevel: (level: number) => void,
) {
  const context = new AudioContext();
  void context.resume().catch(() => {});
  const analyser = context.createAnalyser();
  analyser.fftSize = 1024;
  context.createMediaStreamSource(stream).connect(analyser);
  const data = new Float32Array(analyser.fftSize);
  let frame = 0;
  let last = performance.now();
  let smoothed = 0;
  onLevel(0);
  const draw = () => {
    const now = performance.now();
    const elapsed = now - last;
    if (elapsed >= 32) {
      analyser.getFloatTimeDomainData(data);
      const rms = Math.sqrt(
        data.reduce((sum, sample) => sum + sample * sample, 0) / data.length,
      );
      // Map quiet speech to a visible level, with silence below -60 dB.
      const target = Math.min(
        1,
        Math.max(0, (20 * Math.log10(Math.max(rms, 0.000001)) + 60) / 54),
      );
      // Catch syllables quickly, then settle gently between words.
      const response = target > smoothed ? 45 : 180;
      smoothed += (target - smoothed) * (1 - Math.exp(-elapsed / response));
      onLevel(smoothed < 0.001 ? 0 : smoothed);
      last = now;
    }
    frame = requestAnimationFrame(draw);
  };
  draw();
  return () => {
    cancelAnimationFrame(frame);
    if (context.state !== "closed") void context.close().catch(() => {});
  };
}
